export const TOGGLE_PASSENGER_EDIT = "passengerEdit/TOGGLE_EDIT"
export const SHOW_PAX_EDIT_OFFER = "passengerEdit/SHOW_PAX_EDIT_OFFER"
export const SHOW_PAX_EDIT_OFFER_FROM_LOADING = "passengerEdit/SHOW_PAX_EDIT_OFFER_FROM_LOADING"
export const DELETE_CORRECTION = "passengerEdit/DELETE_CORRECTION"
export const SET_PASSENGER_EDIT_STEP = "passengerEdit/SET_PASSENGER_EDIT_STEP"
export const CLEAR_USER_EDITING = "passengerEdit/CLEAR_USER_EDITING"
export const SET_NEW_PASSENGER_DATA = "passengerEdit/SET_NEW_PASSENGER_DATA"
export const TOGGLE_LOADING = "passengerEdit/TOGGLE_LOADING"
export const TOGGLE_LEAVE_CONFIRMATION_PASSENGER_EDIT = "passengerEdit/TOGGLE_LEAVE_CONFIRMATION"
export const SUBMIT_EDIT_USER_FORM = "passengerEdit/SUBMIT_EDIT_USER_FORM"
export const SUBMIT_ORDER_CORRECTION_FAILURE = "passengerEdit/ORDER_CORRECTION_FAILURE"
export const PASSENGER_EDIT = "passenger_edit"
export const PAX_EDIT_STATUS = {
  DETERMINED: "determined",
  BACKOFFICE: "backoffice",
  COMPLETED: "processed",
} as const
